import { HIERARCHY_TYPE_WITH_MANDATORY_CONTACT_HP_ROLES } from 'clickNgo/entities/partner/configs'
import { THierarchyType } from 'clickNgo/entities/partner/models'

export const checkHierarchyTypeWithMandatoryContactHPRoles = (hierarchyType: THierarchyType) =>
  HIERARCHY_TYPE_WITH_MANDATORY_CONTACT_HP_ROLES.includes(hierarchyType)
